import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const SearchBar = ({ onSearch }) => {
  const handleChange = (e) => {
    // 实时搜索：输入时立即触发搜索
    onSearch(e.target.value);
  };

  return (
    <div className="search-bar">
      <Input
        placeholder="搜索书签（标题、网址、描述）"
        allowClear
        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
        onChange={handleChange}
        className="search-input"
      />
    </div>
  );
};

export default SearchBar; 